<template>
  <van-popup v-model="show" :overlay=false :style="{ width: '100%', height: '100vh' }">
    <div class="withdraw-container">
      <!-- 标题栏 -->
      <div class="pc-title pc-title1">
        <p class="icon">
          <i @click="closePopup" class="el-icon-close"></i>
        </p>
        <span>提现</span>
      </div>

      <div class="wp-con">
        <div class="cz-img">
          <img class="close-icon" src="~@/assets/imgs/tx.png" alt="">
        </div>
        

      </div>

      <div>
        <!-- 钱包地址 -->
        <div class="wallet-address">
          <p class="section-label">钱包地址</p>
          <p class="address-input">{{formatAddress(accountInfo)}}</p>
        </div>
        <!-- 提现金额选择 -->
        <div class="amount-selection">
          <p class="section-label">可提现金额</p>
          <div style="position: relative">
            <div class="amount-input">{{Number(txBalance) < 0 ? 0 :$formatDecimals(txBalance)}}</div>
            <div class="currency-label">USDT</div>
          </div>

          <p class="gas-fee">Gas 余额: {{$formatDecimals(balance)}} USDT (5U赠送金不可提现)</p>
        </div>
        <!-- 底部按钮 -->
        <div class="action-footer">
          <button class="ty-button ty-button1" @click="closePopup">取消</button>
          <button class="ty-button" @click="confirmWithdraw">确认</button>
        </div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import {mapState} from "vuex";
import Decimal from "decimal.js";

export default {
  name: 'WithdrawPopup',
  props: ["show","balance"],
  data() {
    return {
      txBalance:0,
    };
  },
  computed: {
    ...mapState([
      "accountInfo",
    ]),
  },
  watch: {
    balance: {
      handler() {
        const vm = this
        vm.txBalance = new Decimal(vm.balance).minus(5).toString();
        if(Number(vm.txBalance) < 0){
          return 0
        }
      }
    }
  },
  methods: {
    // 格式化地址显示
    formatAddress(address) {
      if (!address) return '';
      return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
    },
    closePopup() {
      this.$emit('update:show', false);
    },
    confirmWithdraw() {
      if (Number(this.txBalance) <= 0) {
        this.$toast('暂无可提现金额~');
        return;
      }else{
        this.$toast('提现功能暂未开放~');
      }
      // this.closePopup();
    }
  }
};
</script>

<style lang="scss" scoped>
.withdraw-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  
  .wp-con {
    flex: 1;
    overflow: hidden;
  }
  
  .cz-img {
    display: flex;
    align-items: center;
    justify-content: center;
    img{
      display: block;
      width: 100%;
    }
  }
}

.wallet-address,
.amount-selection {
  padding:10px 20px;
  
  .section-label {
    font-size: 16px;
    font-weight: 500;
    margin-bottom: 10px;
    color: #000;
  }
  
  .address-input,
  .amount-input {
    width: 100%;
    height: 52px;
    line-height: 52px;
    border: 0.5px solid $border;
    border-radius: 8px;
    padding: 0 15px;
    font-size: 14px;
    color: $color1;
    outline: none;
  }
  .amount-input{
    padding: 0 60px 0 15px;
  }
}

.amount-selection {
  position: relative;
  
  .currency-label {
    position: absolute;
    right: 15px;
    top: 16.5px;
    font-size: 14px;
    color: #000;
  }
  
  .gas-fee {
    margin-top: 10px;
    font-size: 14px;
    color: $color1;
  }
}

.action-footer {
  margin-top: auto;
  padding: 20px;
  display: flex;
  gap: 10px;
  
  button {
    height: 44px;
    line-height: 44px;
  }
}
</style>